//NPM LIBRARIES
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AUselect from '@gov.au/select';
import AUtextInput from '@gov.au/text-inputs';
import { AUlabel, AUformGroup } from '@gov.au/form';
//REDUX ACTIONS AND SELECTORS
import { getReferenceDataSelector } from '../../../FormStore/Selectors/FormDataSelectors'
//COMPONENTS AND UTILITIES
import { validateAnswerHasValue } from '../../CASAForm/Utilities';

const numberOnlyRegexPattern = new RegExp("^[0-9]*$")

class MeasurementInput extends Component {

    constructor(props) {
        super(props);

        let answer = {
            value: '',
            subAnswers: {
                inputValue: '',
                suffixValue: ''
            }
        };
        let errorMessage = ''

        if (props.existingAnswer) {
            answer = props.existingAnswer

        } else {
            if (props.initvalue) {
                answer.subAnswers.inputValue = props.initvalue
            }

            if (props.initSelection) {
                answer.subAnswers.suffixValue = props.initSelection;
                answer.subAnswers.suffixCode = props.distanceUnitTypes.find(c => c.casa_code === answer.subAnswers.suffixValue).enccode;
            }
        }

        if (props.mandatory) {
            errorMessage = validateAnswerHasValue(props.type, answer, props.mandatory);
        }

        this.state = {
            answer: answer,
            errorMessage: errorMessage
        }
    }

    onBlur = (e) => {
        let errorMessage = validateAnswerHasValue(this.props.type, this.state.answer, this.props.mandatory);
        
        let answer = {
            value: this.state.answer.subAnswers.inputValue + this.state.answer.subAnswers.suffixValue.toLowerCase(),
            subAnswers: {
                inputValue: this.state.answer.subAnswers.inputValue,
                suffixValue: this.state.answer.subAnswers.suffixValue,
                suffixCode: this.props.distanceUnitTypes.find(c => c.casa_code === this.state.answer.subAnswers.suffixValue).enccode, // + "1",
                suffixType: 'Distance Unit Type'
            }
        }

        this.setState({errorMessage: errorMessage});

        let questionObject = {
            stepid: this.props.stepid,
            id: this.props.id,
            validate: this.props.validate,
            errorMessage: errorMessage,
            mandatory: this.props.mandatory,
            show: this.props.show,
            label: this.props.label,
            type: this.props.type,
            answer: answer
        }

        if (this.props.onChange) {
            this.props.onChange(questionObject)
        }

        this.props.returnQuestionData(questionObject);
    };

    onChangeInput = (e) => {
        if (!numberOnlyRegexPattern.test(e.target.value)) {
            return
        }

        this.setState({
            answer: {
                subAnswers: {
                    ...this.state.answer.subAnswers,
                    inputValue: e.target.value,
               }
            }
        })
    }

    onChangeSelect = (e) => {
        this.setState({
            answer: {
                subAnswers: {
                    ...this.state.answer.subAnswers,
                    suffixValue: e.target.value,
                    suffixCode: this.props.distanceUnitTypes.find(c => c.casa_code === e.target.value).enccode
                }
            }
        })
    }

    getDistanceSuffixOptions = () => {
        const referenceData = this.props.distanceUnitTypes;

        if (!referenceData) {
            return null
        }
        return referenceData.map(item => {
            return {
                value: item.casa_code, //.toLowerCase(),
                text: item.casa_name.toLowerCase(),
                code: item.enccode
            }
        })
    }

    render() {
        return (
            <AUformGroup
                className="question-group"
                status={this.props.getStatus(this.state.errorMessage)} >
                <div className="display-flex-end">
                    <AUformGroup
                        className="casa-inline-form-subgroup  casa-inline-form-subgroup-lg"
                        status={this.props.getStatus(this.state.errorMessage)} >

                        <AUlabel text={this.props.label} htmlFor={this.props.id} />
                        <AUtextInput
                            type="text"
                            id={`Input${this.props.id}`}
                            name={this.props.id}
                            aria-describedby={`${this.props.id}-error`}
                            status={this.props.getStatus(this.state.errorMessage)}
                            onChange={this.onChangeInput}
                            onBlur={this.onBlur}
                            value={this.state.answer.subAnswers.inputValue}
                            block
                            placeholder={this.props.placeholder}
                        />
                    </AUformGroup>

                    <AUformGroup
                        className="casa-inline-form-subgroup"
                        status={this.props.getStatus(this.state.errorMessage)}>
                        <AUlabel text="Unit type" htmlFor={this.props.id} />
                        <AUselect
                            className="casa-inline-form-subgroup"
                            id={`Suffix${this.props.id}`}
                            name={this.props.id}
                            aria-describedby={`${this.props.id}-error`}
                            questionid={this.props.id}
                            options={this.getDistanceSuffixOptions()}
                            status={this.props.getStatus(this.state.errorMessage)}
                            onChange={this.onChangeSelect}
                            onBlur={this.onBlur}
                            value={this.state.answer.subAnswers.suffixValue}
                        />

                    </AUformGroup>
                </div>
                {this.props.toolTip ? <span className="au-hint-text">{this.props.toolTip}</span> : ""}
                {this.props.createErrorMessage(this.state.errorMessage)}
            </AUformGroup>
        );
    }
}

MeasurementInput.propTypes = {
    id: PropTypes.string.isRequired,
    stepid: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    initvalue: PropTypes.string,
    initSelection: PropTypes.string,
    validate: PropTypes.func,
    mandatory: PropTypes.bool.isRequired,
    enabled: PropTypes.bool.isRequired,
    show: PropTypes.bool.isRequired,
    type: PropTypes.string,
    toolTip: PropTypes.string,
    placeholder: PropTypes.string,
    existingAnswer: PropTypes.object,
    createErrorMessage: PropTypes.func,
    getStatus: PropTypes.func,
    onChange: PropTypes.func,
    returnQuestionData: PropTypes.func,
    distanceUnitTypes: PropTypes.array
};

const mapStateToProps = (state) => {
    return {
        distanceUnitTypes: getReferenceDataSelector(state.crmReferenceData, 'Distance Unit Type')
    }
}

export default connect(mapStateToProps)(MeasurementInput);